/* (c) Copyright Frontify Ltd., all rights reserved. */

export const SOFT_BREAK_PLUGIN = 'soft-break-plugin';
